<template>
	<div>
		<div class="modal-wrapper" :class="{ 'is-open': isOpened }">
			<div class="modal">
				<div class="modal-content">
					<a href="#" @click.stop.prevent="close" class="close-button"
						><i class="icons8-jobapp-delete-01"></i>
					</a>
					<div class="notification-content">
						<div class="check-wrapper">
							<img src="/static/img/checkmark.svg" />
						</div>
						<div class="body-wrapper">
							<h1 class="notification-header">
								Achievement Unlocked!
							</h1>
							<form @submit.prevent="handleSubmit" id="form">
								<p class="notification-body">
									You need to verify your email address. Check
									your inbox for a verification email. If you
									have any questions, please contact us at
									<a href="mailto:jobs@bohemia.net"
										>jobs@bohemia.net</a
									>
									<br /><br />
									Respawn at
									<a href="/">Bohemia.net/careers</a>
								</p>
							</form>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-backdrop" @click.stop="close"></div>
		</div>
	</div>
</template>

<script>
import BasicButton from "../BasicButton";
import {
	minLength,
	required,
	maxLength,
	email
} from "vuelidate/lib/validators";
import { postNewsletter } from "../../services/newsletter";

export default {
	name: "ModalWindow",
	data() {
		return {
			isOpened: false
		};
	},
	components: { BasicButton },
	methods: {
		close() {
			this.isOpened = false;
		},
		open() {
			this.isOpened = true;
		}
	}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/globals";
@import "../../assets/scss/typography";

.newsletter-form {
	padding: 1.4em;
	border-color: #505050;
}

.close-button {
	color: #fff;
	padding: 1em;
	position: absolute;
	top: -4px;
	right: -4px;
	i {
		font-size: 30px;
	}
}
.check-wrapper {
	img {
		border-radius: 50%;
		border: 8px solid #fff;
		padding: 16px;
	}
}
.modal-backdrop {
	position: fixed;
	z-index: 10002;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(0, 0, 0, 0.6);
}

.modal-wrapper {
	visibility: hidden;
	opacity: 0;
	position: fixed;
	top: 0;
	bottom: 0;
	display: flex;
	left: 0;
	right: 0;
	justify-content: center;
	align-items: center;
	z-index: 10001;
	transition: all 0.5s ease-out;
}

.modal {
	max-width: 920px;
	position: fixed;
	z-index: 10003;
	transform: translateY(-1000px);
	background-color: #16bb7c;
	overflow-x: auto;
	display: flex;
	flex-direction: column;
	margin-right: 10px;
	margin-left: 10px;
	padding: 0.5em;
	-webkit-box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.25);
	-moz-box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.25);
	box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.25);
	transition: all 0.5s ease-out;
	.modal-content {
		position: relative;
		padding: 1em;
		@media (max-width: $compact) {
			padding: 1em;
		}
	}
}

.is-open {
	visibility: visible;
	opacity: 1;
	.modal {
		transform: translateY(0px);
	}
}

.notification-header {
	color: #fff;
	letter-spacing: 0.68px;
	line-height: 45px;
	font-weight: 800;
	font-size: 34px;
	font-family: Montserrat, sans-serif;
	text-transform: capitalize;
}

.notification-body {
	color: #fff;
	letter-spacing: 0.81px;
	line-height: 24px;
	font-weight: 300;
	font-size: 18px;
	font-family: Montserrat, sans-serif;
	a {
		text-decoration: underline;
		color: #fff;
	}
	a:visited {
		color: #fff;
	}
}
.notification-content {
	display: flex;
	padding: 20px;
	padding-top: 30px;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
	flex-wrap: wrap;
	@media (max-width: 540px) {
		text-align: center;
		justify-content: center;
	}
	.check-wrapper {
		padding-right: 35px;
		padding-top: 25px;
		@media (max-width: 540px) {
			width: 100%;
			padding: 0;
		}
	}
	.body-wrapper {
		flex: 1;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/SubscribeNotification.vue